const TEAM_PAGE_SIZE = 200;

// Hierarchy screens derive counts from the complete visible team set. Keep
// paging until the scoped API returns a short (or empty) page so those counts
// do not silently truncate at the endpoint's per-request cap.
export const fetchAllTeams = async (client) => {
  const teams = [];
  let offset = 0;

  while (true) {
    const response = await client.get("/teams", {
      params: { limit: TEAM_PAGE_SIZE, offset },
    });
    const page = Array.isArray(response.data) ? response.data : [];
    teams.push(...page);
    if (page.length < TEAM_PAGE_SIZE) return teams;
    offset += page.length;
  }
};
